var _effectorFileName = "/builds/gmini/front-ui-kit/src/ToggleSwitch/ToggleSwitch.styled.ts";
import styled from 'styled-components';
const toggleSwitchSize = {
  small: {
    widthSwitchPx: 20,
    heightSwitchPx: 12,
    borderRadiusSwitchPx: 12,
    widthKnobPx: 8,
    paddingPx: 2
  },
  smedium: {
    widthSwitchPx: 27,
    heightSwitchPx: 16,
    borderRadiusSwitchPx: 12.8,
    widthKnobPx: 12,
    paddingPx: 2
  },
  medium: {
    widthSwitchPx: 32,
    heightSwitchPx: 20,
    borderRadiusSwitchPx: 16,
    widthKnobPx: 16,
    paddingPx: 2
  }
};
export const Switch = styled.div`
  padding: ${props => toggleSwitchSize[props.size].paddingPx}px;
  border-radius: ${props => toggleSwitchSize[props.size].borderRadiusSwitchPx}px;
  width: ${props => toggleSwitchSize[props.size].widthSwitchPx}px;
  min-width: ${props => toggleSwitchSize[props.size].widthSwitchPx}px;
  height: ${props => toggleSwitchSize[props.size].heightSwitchPx}px;
  background: ${props => props.active ? props.color : 'rgba(53, 59, 96, 0.3)'};
  ${props => props.disabled && 'background: rgba(0, 5, 100, 0.04);'}
  transition: background-color 0.2s ease-out;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};

  &:hover {
    background: ${props => props.disabled ? 'rgba(0, 5, 100, 0.04)' : 'rgba(53, 59, 96, 0.2)'};
    ${props => props.active && props.hoverColor && `background: ${props.hoverColor};`}
  }

  &:active {
    background: ${props => props.disabled ? 'rgba(0, 5, 100, 0.04)' : 'rgba(53, 59, 96, 0.2)'};
    ${props => props.active && props.selectedColor && `background: ${props.selectedColor};`}
  }
`;
export const Knob = styled.div`
  position: relative;
  transition: left 0.2s ease-out;
  left: ${props => props.active ? Number(toggleSwitchSize[props.size].widthSwitchPx) - Number(toggleSwitchSize[props.size].widthKnobPx) - Number(toggleSwitchSize[props.size].paddingPx) * 2 : 0}px;
  width: ${props => toggleSwitchSize[props.size].widthKnobPx}px;
  background: #fff;
  border-radius: 50%;

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`;